import styled, { css } from 'styled-components';
import { Chip } from '@mui/material';
import colors from '../../../../../styles/colors';

const ActivityContentContainer = styled.div`
  display: flex;
  font-size: 14px;
  line-height: 16px;
  padding: 8px 20px;
  margin: 4px 0 16px;
  white-space: pre-wrap;

  ${({ isLastAssignedDateInPast }) => isLastAssignedDateInPast
    && css`
      color: ${colors.base.danger};
      font-weight: bold;
    `}
`;

const CriteriaChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 20px;
  margin: 4px 0 16px;
`;

const CriteriaChip = styled(Chip)`
  font-size: 12px;
  font-weight: 500;
`;

export {
  ActivityContentContainer,
  CriteriaChipsContainer,
  CriteriaChip,
};
